import { Injectable, inject } from '@angular/core'
import { environment } from '../../environments/environment'
import { FprTemplate } from '../types/fprTemplates'
import { catchError, map, Observable } from 'rxjs'
import { HttpClient } from '@angular/common/http'
import { ErrorService } from './error.service'

@Injectable({
  providedIn: 'root',
})
export class FprTemplatesService {
  private http = inject(HttpClient)
  private errorService = inject(ErrorService)

  private URL = environment.baseUrl + 'fpr-templates'

  /**
   * Creates a FPR template
   * @param {FprTemplate} template The template data
   * @returns {Observable<void>}
   */
  create(template: FprTemplate): Observable<void> {
    return this.http.post<void>(this.URL, template).pipe(
      map((res: void) => {
        return res
      }),
      catchError(this.errorService.handleError),
    )
  }

  /**
   * Gets all FPR templates for a company
   * @returns {Observable<Array<FprTemplate>>} The FPR templates found
   */
  getAll(): Observable<Array<FprTemplate>> {
    return this.http
      .get<Array<FprTemplate>>(this.URL)
      .pipe(catchError(this.errorService.handleError))
  }

  /**
   * Gets a FPR template by id
   * @param {string} id The template id
   * @returns {Observable<FprTemplate>} Result
   */
  getById(id: string): Observable<FprTemplate> {
    return this.http
      .get<FprTemplate>(this.URL + `/${id}`)
      .pipe(catchError(this.errorService.handleError))
  }

  /**
   * Sends the request to update a FPR template
   * @param {string} id The template id
   * @param {FprTemplate} updates The template updates
   * @returns {Observable<void>}
   */
  edit(id: string, updates: FprTemplate): Observable<void> {
    return this.http
      .put<void>(this.URL + `/${id}`, updates)
      .pipe(catchError(this.errorService.handleError))
  }

  /**
   * Sends the request to delete a FPR template
   * @param {string} id The template id
   * @returns {Observable<void>}
   */
  delete(id: string): Observable<void> {
    return this.http
      .delete<void>(this.URL + `/${id}`)
      .pipe(catchError(this.errorService.handleError))
  }

  /**
   * Downloads a FPR template by id
   * @param {string} id The template id
   * @returns {Observable<string>} Base64 result
   */
  download(id: string): Observable<string> {
    return this.http
      .get<{ templateBase64: string }>(this.URL + `/${id}/download`)
      .pipe(
        map((res) => res.templateBase64),
        catchError(this.errorService.handleError),
      )
  }
}
